module.exports = __webpack_public_path__ + "img/big.6dc824f9.jpg";